import { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';

// components
import MainLoadingComponent from 'components/mainLoadingComponent/loadingComponent';

// services
import { getDefaultLanguage } from 'core/services/language';
import { getCountriesCode } from 'components/phoneInput/countriesService';
import { axiosRequestInterceptor } from 'core/services/interceptor';
import authService, { getUserFromToken } from 'core/services/auth';

// styles
import './assets/styles/customAntComponents.scss';
import 'assets/styles/app.scss';
import { useDispatch } from 'react-redux';
import { setAdmin } from 'stores/useAdminStore';
import { setCompany } from 'stores/useCompanyStore';

function App() {
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const location = useLocation();

	const [loadingData, setLoadingData] = useState(true);

	axiosRequestInterceptor();

	useEffect(() => {
		document.body.dir = getDefaultLanguage() == 'ar' ? 'rtl' : 'ltr';

		getData();
	}, []);

	const getData = async () => {
		try {
			await Promise.all([getCountriesCode(), onGetUser()]);

			setTimeout(() => {
				setLoadingData(false);
			}, 300);
		} catch (error) {
			setTimeout(() => {
				setLoadingData(false);
			}, 300);
		}
	};

	const onGetUser = async () => {
		try {
			if (authService.token) {
				const response = await getUserFromToken();

				authService.setData(response.is_main_user, response.permissions, response.registration_step);
				dispatch(setAdmin(response.company_user));
				dispatch(setCompany(response.company_user.company));

				switch (response.registration_step) {
					case 'contact_person':
						navigate('/register/otp');
						break;
					case 'phone_verified':
						navigate('/register/company');
						break;
					case 'company_profile':
						navigate('/register/plans');
						break;
					case 'plan_select':
						navigate('/register/agreement');
						break;
					default:
						if (!location.pathname.startsWith('/dashboard') && !location.pathname.startsWith('/public')) {
							navigate('/dashboard');
						}
				}
			}
		} catch (error) {
			navigate('/');
			authService.clearAuthData();
		}
	};

	return loadingData ? <MainLoadingComponent /> : <Outlet />;
}

export default App;
